<template>
    <v-container class="pa-0 pb-12">
		<v-row class="px-3 fill-height"><v-col>
				<v-alert type="success">
			<template v-if="IsAuthenticated">{{ $t('text.eventReg.finishedTextAuth') }}</template>
			<template v-else>{{ $t('text.eventReg.finishedTextUnauth') }}</template>
				</v-alert>
		</v-col></v-row>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex';

import namespace from '../store/namespace';

export default {
	name: 'RegistrationFinished',
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
	},
};
</script>

<style lang="scss" scoped>
	@import "../globalComponents/style/_globals";

	.fill-height {
		color: $font-light-color;
	}
</style>
